import dayjs from "dayjs";
import { Outlet, useOutletContext } from "react-router-dom";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
export default function Financeiro() {
  const { apiCliente, controllerDashboard, setControllerDashboard } =
    useOutletContext();

  return (
    <>
      <Outlet
        context={{
          controllerDashboard,
          setControllerDashboard,
          apiCliente,
        }}
      />
    </>
  );
}
